import { render, staticRenderFns } from "./WorkComponent.vue?vue&type=template&id=542fa54b&"
import script from "./WorkComponent.vue?vue&type=script&lang=js&"
export * from "./WorkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports